import axios, { AxiosError, AxiosRequestHeaders } from "axios";
import { toast } from "react-toastify";
import { clearCredentials, revalidateAuth } from "../components/utils";
import { useAuthStore } from "../store";

const AUTH_ERROR_TOAST_ID = "auth-no-access";

function handleUnauthorizedAccess() {
  clearCredentials();
  useAuthStore.setState((store) => ({ ...store, isAuthenticated: false }));
  if (!toast.isActive(AUTH_ERROR_TOAST_ID)) {
    toast("No access", {
      type: "error",
      toastId: AUTH_ERROR_TOAST_ID,
      autoClose: 2000,
    });
  }
}

const onBoardingApi = axios.create({
  baseURL:
    process.env.REACT_APP_ONBOARDING_URL ||
    "https://onboarding-api.hissa.com/v1/",
});

onBoardingApi.defaults.headers.post["Content-Type"] = "application/json";

onBoardingApi.interceptors.request.use((config) => {
  const accesstoken =
    localStorage.getItem("accesstoken") || useAuthStore.getState().accessToken;
  revalidateAuth();
  if (accesstoken && !config.url?.endsWith("/login")) {
    (config.headers as AxiosRequestHeaders).AccessToken = accesstoken;
  }
  if (config.url === "exit") {
    delete (config.headers as AxiosRequestHeaders).AccessToken;
  }
  return config;
});

onBoardingApi.interceptors.response.use(
  (res) => {
    if (res.status === 401) {
      handleUnauthorizedAccess();
      return Promise.reject(res);
    }
    return res;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      handleUnauthorizedAccess();
    }
    return Promise.reject(error);
  },
);

export default onBoardingApi;
